import { Base64 } from 'js-base64';
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import logo from '../../../../assets/images/logo/Haylo-for-white-background.png'
import http, { URL_S3 } from '../../../../config/BaseUrl';

function MicrositeTwo() {


  const { id } = useParams()
  const eventId = Base64.atob(id);
  const [galleryItems, setGalleryItems] = useState([]);

  const fetchMicroSiteGalleryItems = async () => {
    try {
      await http.get(`social-gallery-item/${eventId}`).then((res) => {
        if (res) {
          setGalleryItems(res.data.gallery_items)
        }
      })
    } catch (error) {

    }
  }

  useEffect(() => {
    fetchMicroSiteGalleryItems()
  }, [])

  return (

    <div className="customer-microsite-two">
      <div className="header default-header">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="header-image text-center py-4">
                <img src={logo} className="img-fluid" alt="logo" style={{ width: "250px" }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-body mt-5 microsite-item-body py-5">
        <div className="container">
          <div className="row justify-content-center">
            {galleryItems && galleryItems.map((res) => (
              <div className={`${galleryItems.length > 2 ? 'col-4' : 'col-6'}`}>
                <div className="gallery-item text-center">
                  <Link to={`/gallery/share/view/one/${Base64.btoa(id)}`}>
                    <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid img-thumbnail" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-microsite-one">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p className="text-center footer-name">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
            </div>
          </div>
        </div>
      </div>

    </div>

  )
}

export default MicrositeTwo
